const rol = JSON.parse(localStorage.getItem('role') || "[]")
const validateRol = rol.includes('Administrador')
export const columnsRoles = [
  { text: 'Punto de venta', value: 'store_name'},
  { text: 'Prefijo', value: 'prefix', align: 'center' },
  { text: 'Consecutivo Factura', value: 'consecutive', align: 'center' },
  { text: 'Estado', value: 'status', align: 'center' },
  { text: 'Fecha Factura', value: 'invoice_date' },
  { text: 'Fecha Creación', value: 'created_at' },
  { text: 'Detalle Factura', value: 'detalleFactura', align: 'center' },
  { text: 'ClaveAcceso', value: 'access_key', align: 'center' },
  { text: 'PDF', value: 'url_pdf_notification', align: 'center' },
  { text: 'Reenvia Factura', value: 'reenviarEmail', align: 'center' },

]

if (validateRol) {
  columnsRoles.push({ text: 'Reprocesa Factura ', value: 'reprocesarFactura', align: 'center' })
  columnsRoles.push({ text: 'Cambiar Estado', value: 'cambiarEstado', align: 'center' })
  columnsRoles.push({ text: 'UrlXMLRecepcion', value: 'url_xml_reception', align: 'center' })
  columnsRoles.push({ text: 'UrlXMLAutorizacion', value: 'url_xml_authorization', align: 'center' })
}

export const columnsRolesDetail = [
  { text: 'Consecutivo Factura', value: 'document_consecutive', align: 'center' },
  { text: 'Estado', value: 'status', align: 'center' },
  { text: 'Mensaje Respuesta', value: 'message', align: 'center' },
  { text: 'Codigo Respuesta', value: 'response_code', align: 'center' },
  { text: 'Fecha Envio', value: 'sent_at' },
  { text: 'Fecha Respuesta', value: 'response_at', align: 'center' },
]

if (validateRol) {
  columnsRolesDetail.push({ text: 'Xml Hiopos', value: 'url_xml_origen', align: 'center' })
  columnsRolesDetail.push({ text: 'Json Enviado', value: 'json', align: 'center'})
}
